import { buildInteractiveResult, Result } from '@coveo/headless';
import { Link } from '@lmig/lmds-react-link';
import { useRef, useState } from 'react';
import { useCoveoSearchEngine } from '../CoveoSearchEngine';
import { isOneBrand } from 'Foundation/Configurations/GlobalConfiguration';
import { GetProductGuideModal, ProductGuideModal, ProductGuideModalObject } from 'Feature/PageContent/Models/ProductGuideModal';

interface ILinkProps {
  result: Result;
  children?: any;
  target?: string;
}

export function ResultLink(props: ILinkProps) {
  const { headlessEngine } = useCoveoSearchEngine();
  const interactiveResult = useRef(
    buildInteractiveResult(headlessEngine!, {
      options: { result: props.result },
    }),
  );
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalHeader, setModalHeader] = useState<string>('');
  const [modalBody, setModalBody] = useState<string>('');

  const isProductGuide = () => {
    const contentType: any = props.result.raw.lmccontenttype;
    return Array.isArray(contentType) && contentType.length > 0 && contentType[0] === 'Product Guide';
  };

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    e.preventDefault();
    interactiveResult.current.select();

    if (!modalBody && !modalHeader) {
      GetProductGuideModal().then((result: ProductGuideModalObject) => {
        if (result.ErrorMessage.length === 0) {
          setModalHeader(result.ModalHeader);
          setModalBody(result.ModalBody);
        } else {
          console.error('GetProductGuideModal');
          console.error(result.ErrorMessage);
        }
      });
    }
    setIsModalOpen(true);
  };

  const onModalButtonClicked = () => {
    setIsModalOpen(false);
    window.open(props.result.clickUri, props.target ?? '_self');
  }

  return (
    <>
      {isOneBrand() && isProductGuide() ? (
        <>
          <Link
            href='#'
            className="search-facet-link"
            onClick={handleLinkClick}
          >
            {props.children}
          </Link>
          <ProductGuideModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onConfirm={onModalButtonClicked}
            modalHeader={modalHeader}
            modalBody={modalBody}
          />
        </>
      ) : (
        <Link
          className="search-facet-link"
          href={props.result.clickUri}
          target={props.target ?? '_self'}
          onClick={() => interactiveResult.current.select()}
        >
          {props.children}
        </Link>
      )}
    </>
  );
}
